import React, { useContext, useEffect, useState } from "react";
import {
  faTimes,
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import * as a from "../../../../constants/api";
import * as r from "../../../../constants/routes";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import ListUsers from "../../../../components/Lists/ListUsers";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import pClasses from "../Users.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import SessionContext from "../../../../context/sessionContext";
import Spinner from "../../../../components/Spinner";
import Title from "../../../../components/Title";
import useFetch from "../../../../hooks/useFetch";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

interface Users {
  access_code: string;
  active: number;
  activity_type: number;
  amt_plays: number;
  birthdate: string;
  company_uid: string;
  context: string;
  date_IA_finish: string;
  date_IA_start: string;
  date_created: string;
  date_last_play: string;
  date_updated: string;
  group_name: string;
  group_uid: number;
  is_email: false;
  journey_code: number;
  permission: string;
  professional_email: string;
  professional_sub: string;
  registry: string;
  shots: number;
  user_id: number;
}
interface Group {
  company_uid: string;
  id: number;
  name: string;
  status: string;
}
interface ConfigFields {
  userStatus: {
    editable: boolean;
    hide: boolean;
  };
  registry: {
    editable: boolean;
    hide: boolean;
  };
  group_name: {
    editable: boolean;
    hide: boolean;
  };
  birthdate: {
    editable: boolean;
    hide: boolean;
  };
  date_IA_start: {
    editable: boolean;
    hide: boolean;
  };
  date_IA_finish: {
    editable: boolean;
    hide: boolean;
  };
  access_code: {
    editable: boolean;
    hide: boolean;
  };
  status: {
    editable: boolean;
    hide: boolean;
  };
  amt_plays: {
    editable: boolean;
    hide: boolean;
  };
  date_last_play: {
    editable: boolean;
    hide: boolean;
  };
  professional_email: {
    editable: boolean;
    hide: boolean;
  };
  toolbox: {
    editable: boolean;
    hide: boolean;
  };
  url: {
    editable: boolean;
    hide: boolean;
  };
}

export default function UserList() {
  const history = useNavigate();
  const { t } = useTranslation();
  const cSession = useContext(SessionContext);

  const [isInfoOpen, setShowInfo] = useState(false);
  const [open, setOpen] = useState(false);
  const [optionsGroups, setOptionsGroups] = useState<any>([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [successAddUsersToGroup, setSuccessAddUsersToGroup] = useState(true);
  const [ModalGroups, setModalGroups] = useState<any>(null);
  const [handleGroup, setHandleGroup] = useState<Group[]>([]);
  const [hasUserChangedGroup, setHasUserChangedGroup] =
    useState<boolean>(false);
  const [listUser, listUserIsLoading, listUserError, listUserFetch]: any =
    useFetch({
      autoInit: false,
    });
  const fHasUserChangedGroup = (): boolean | void =>
    setHasUserChangedGroup(!hasUserChangedGroup);
  const { company_uid } = cSession ?? {};
  const { is_admin } = cSession ?? {};
  const { sub } = cSession.admin ?? {};

  useEffect(() => {
    if (sub) listUserFetch({ url: a.API_USERS_ALL_SMART });
  }, [listUserFetch, sub, hasUserChangedGroup]);
  const hasNewGroups = () => {
    listUserFetch({ url: a.API_USERS_ALL_SMART });
  };
  let _content = null;
  const hasUser = listUser && listUser.length > 0 ? true : false;
  const [, isLoadingAddGroup, , fetchUserGroup]: any = useFetch({
    autoInit: false,
  });
  const START_MODAL_STEPS = 1;
  const SUCCESS_MODAL_STEPS = 2;
  const ERROR_MODAL_STEPS = 3;
  const LOADING_MODAL_STEPS = 4;

  // cases pages
  const IS_LOADING_USERS = "listUserIsLoading";
  const NO_USERS = "noUsers";
  const HAS_USERS = "hasUser";
  const ERROR_USERS = "errorUsers";

  const setStepsModal = (
    step: number,
    users: Users[],
    groupChoosed: Group,
    groupId: number,
    usersIds: number[]
  ) => {
    switch (step) {
      case START_MODAL_STEPS:
        setModalGroups(
          <Dialog
            open={!open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            {
              <>
                <DialogTitle
                  id="alert-dialog-title"
                  className={pClasses.AddGroupToUsersTitleArea}
                >
                  {t("global.add_all_users_to_group")}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-description"
                    className={pClasses.AddGroupToUsersTextArea}
                  >
                    <div>
                      {t("global.all_users_will_be_added_to_this_group")}{" "}
                      <p>
                        {"Usuários: " +
                          users.map((u: Users) => " " + u.registry + " ") +
                          " serão adicionados ao grupo " +
                          groupChoosed?.name}
                        .
                      </p>
                    </div>
                    <div>{t("global.are_you_sure")}</div>
                  </DialogContentText>
                </DialogContent>
                <DialogActions className={pClasses.AddGroupToUsersButtonsArea}>
                  <Button
                    onClick={() => setModalGroups(null)}
                    autoFocus
                    variant="outlined"
                  >
                    {t("global.cancel")}
                  </Button>
                  <Button
                    disabled={isLoadingAddGroup}
                    onClick={() => {
                      return setStepsModal(
                        LOADING_MODAL_STEPS,
                        users,
                        groupChoosed,
                        groupId,
                        usersIds
                      );
                    }}
                    autoFocus
                    variant="contained"
                    color="primary"
                  >
                    {t("global.yes_confirm")}
                  </Button>
                </DialogActions>
              </>
            }
          </Dialog>
        );
        break;
      case 2:
        setModalGroups(
          <div>
            <Dialog
              open={!open}
              onClose={() => setOpen(false)}
              className={pClasses.AddGroupToUsersSuccessModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent
                id="alert-dialog-title"
                className={pClasses.AddGroupToUsersSusseccMsgArea}
              >
                <p>
                  <RoundButton
                    title={"x"}
                    aLink
                    faIcon={faCheckCircle}
                    onClick={() => setOpen(!open)}
                  />
                  Usuários adicionados ao grupo com sucesso!
                </p>
                <div onClick={() => setModalGroups(null)}>X</div>
              </DialogContent>
            </Dialog>
          </div>
        );
        break;
      case 3:
        setModalGroups(
          <div>
            <Dialog
              open={!open}
              onClose={() => setOpen(false)}
              className={pClasses.AddGroupToUsersSuccessModal}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent
                id="alert-dialog-title"
                className={pClasses.AddGroupToUsersSusseccMsgArea}
              >
                <p>
                  <RoundButton
                    title={"x"}
                    aLink
                    faIcon={faExclamationTriangle}
                    onClick={() => setOpen(!open)}
                  />
                  Erro ao adicionar, por favor, tente novamente mais tarde.
                </p>
                <div onClick={() => setModalGroups(null)}>X</div>
              </DialogContent>
            </Dialog>
          </div>
        );
        break;
      case 4:
        fetchUserGroup({
          method: "POST",
          url: a.UPDATE_USER_GROUP,
          data: {
            group_name: groupChoosed?.name,
            group_uid: groupId,
            user_uid: usersIds,
          },
          onSuccess: () => {
            setSelectedRows([]);
            if (sub) listUserFetch({ url: a.API_USERS_ALL_SMART });
            setSuccessAddUsersToGroup(!successAddUsersToGroup);
            return setStepsModal(
              SUCCESS_MODAL_STEPS,
              users,
              groupChoosed,
              groupId,
              usersIds
            );
          },
          onError: () => {
            setSelectedRows([]);
            return setStepsModal(
              ERROR_MODAL_STEPS,
              users,
              groupChoosed,
              groupId,
              usersIds
            );
          },
        });
        setModalGroups(
          <Dialog
            open={!open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            {
              <>
                <DialogTitle
                  id="alert-dialog-title"
                  className={pClasses.AddGroupToUsersTitleArea}
                >
                  {t("global.add_all_users_to_group")}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-description"
                    className={pClasses.AddGroupToUsersTextArea}
                  >
                    <div>
                      {t("global.all_users_will_be_added_to_this_group")}{" "}
                      <p>
                        {t("global.users") +
                          ":" +
                          users.map((u: Users) => " " + u.registry + " ") +
                          t("global.will_be_add_to_group") +
                          groupChoosed?.name}
                        .
                      </p>
                    </div>
                    <div>{t("global.are_you_sure")}</div>
                  </DialogContentText>
                </DialogContent>
                <DialogActions className={pClasses.AddGroupToUsersButtonsArea}>
                  <div>
                    <Spinner extraSmall />
                  </div>
                </DialogActions>
              </>
            }
          </Dialog>
        );
        break;
      default:
        setModalGroups(null);
        break;
    }
  };

  const confirmGroups = (groupId: number, users: Users[]) => {
    const groupChoosed = handleGroup.find((g) =>
      g.id === groupId ? g.name : undefined
    );
    const usersIds = users.map((u: Users) => u.user_id);

    if (users.length === 0) return alert("Sem usuários selecionados");
    if (groupChoosed === undefined) return alert("Sem grupo selecionado");
    setStepsModal(START_MODAL_STEPS, users, groupChoosed, groupId, usersIds);
  };

  useEffect(() => {
    if (handleGroup) {
      const groupOptions = handleGroup
        ?.map((group: Group) => {
          if (group.status === "active")
            return (
              <MenuItem key={group.name} value={group.id}>
                {group.name}
              </MenuItem>
            );
        })
        .filter((item): item is JSX.Element => item !== undefined)
      setOptionsGroups(groupOptions);
    }
  }, [handleGroup]);


  function CustomToolbar() {
    return (
      <div className={pClasses.toolbar}>
        <div>
          <GridToolbarContainer className={pClasses.toolbarIcons}>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarExport />
          </GridToolbarContainer>
        </div>
        <div
          style={{
            display: "flex",
            width: "300px",
            borderStyle: "solid",
            color: "#007085",
            textAlign: "center",
            marginLeft: 'auto',
          }}
        >
          <FormControl
            style={{ width: "100%", color: "#007085", textAlign: "center" }}
          >
            <InputLabel style={{ color: "#007085" }}>
              <FontAwesomeIcon
                className={pClasses.faUserPlusGroup}
                icon={faUserPlus}
              />
              {t("global.add_to_a_group")}
            </InputLabel>
            <Select
              style={{ width: "100%", color: "#007085", textAlign: "center" }}
              onChange={(e) => {
                confirmGroups(
                  Number(e.target.value),
                  selectedRows.map((row: number) => listUser[row])
                );
              }}
              name="group"
              id="group"
              label={t("global.choose")}
            >
              {optionsGroups}
            </Select>
          </FormControl>
        </div>
      </div>
    );
  }

  const [status, setStatus] = useState(IS_LOADING_USERS);
  let infoHowToSend = <></>;
  let configFields: ConfigFields = {
    userStatus: { editable: false, hide: false },
    registry: { editable: false, hide: false },
    group_name: { editable: false, hide: true },
    birthdate: { editable: false, hide: true },
    date_IA_start: { editable: false, hide: true },
    date_IA_finish: { editable: false, hide: false },
    access_code: { editable: false, hide: true },
    status: { editable: false, hide: false },
    amt_plays: { editable: false, hide: false },
    date_last_play: { editable: false, hide: true },
    professional_email: { editable: false, hide: true },
    toolbox: { editable: false, hide: false },
    url: { editable: false, hide: true },
  };
  useEffect(() => {
    if (listUserIsLoading) setStatus(IS_LOADING_USERS);
    if (hasUser) setStatus(HAS_USERS);
    if (
      !hasUser &&
      listUserIsLoading === false &&
      listUserError?.status === 404
    )
      setStatus(NO_USERS);
  }, [listUserIsLoading, listUserError, hasUser]);


  // TODO colocar esse switch em um useEffect que renderize novamente quando for adicionado um novo grupo/usuário

  switch (status) {
    case IS_LOADING_USERS:
      _content = <Spinner center />;
      break;
    case NO_USERS:
      _content = (
        <FriendlyInfo text={t("global.you_does_not_have_users_added")}>
          <RoundButton
            small
            center
            text={t("global.add_users")}
            title={t("global.add_users")}
            onClick={() => history(r.R_A_USERS_ADD_SMART)}
          />
        </FriendlyInfo>
      );
      break;
    case HAS_USERS:
      infoHowToSend = (
        <section className={pClasses.HowToSendArea}>
          <RoundButton
            title={t("global.toggle_how_to_send_to_the_training_a_user")}
            aLink
            text={t("global.how_to_send_to_the_training_a_user")}
            onClick={() => {
              setShowInfo(!isInfoOpen);
            }}
          />
        </section>
      );

      configFields = {
        userStatus: {
          editable: false,
          hide: false,
        },
        registry: {
          editable: false,
          hide: false,
        },
        group_name: {
          editable: false,
          hide: true,
        },
        birthdate: {
          editable: false,
          hide: true,
        },
        date_IA_start: {
          editable: false,
          hide: true,
        },
        date_IA_finish: {
          editable: false,
          hide: false,
        },
        access_code: {
          editable: false,
          hide: true,
        },
        status: {
          editable: false,
          hide: false,
        },
        amt_plays: {
          editable: false,
          hide: false,
        },
        date_last_play: {
          editable: false,
          hide: true,
        },
        professional_email: {
          editable: false,
          hide: true,
        },
        toolbox: {
          editable: false,
          hide: false,
        },
        url: {
          editable: false,
          hide: true,
        },
      };

      if (isInfoOpen) {
        let link_to_show_audiofoco = a.AUDIOFOCO_LINK.replace("https://", "");
        link_to_show_audiofoco = link_to_show_audiofoco.replace("http://", "");

        infoHowToSend = (
          <section className={pClasses.HowToSendArea + " " + pClasses.Open}>
            <RoundButton
              title={
                t("global.toggle") +
                t("global.how_to_send_to_the_training_a_user")
              }
              aLink
              className={pClasses.CloseBtn}
              faIcon={faTimes}
              onClick={() => {
                setShowInfo(!isInfoOpen);
              }}
            />
            <Title h2>{t("global.how_to_send_to_the_training_a_user")}</Title>
            <ul className={pClasses.Infos}>
              <li>
                {t("global.share_the_link") + " "}
                {a.AUDIOFOCO_LINK && (
                  <a target="_blank" href={a.AUDIOFOCO_LINK} rel="noreferrer">
                    {link_to_show_audiofoco + " "}
                  </a>
                )}
                {t("global.with_your_user")}
              </li>
              <li>
                {t("global.info_to_your_user_the") + " "}
                <strong>
                  {t("global.company_id") + " "}
                  {company_uid && `(${company_uid})`}
                </strong>
                {", " + t("global.the_o") + " "}
                <strong>{t("global.user_id")}</strong>,{" "}
                {t("global.create_by_you_and_the") + " "}
                <strong>{t("global.access_code")}</strong>
                {" " + t("global.generated_by_the_system") + " "}
              </li>
              <li>{t("global.ask_to_user_put_these_data_to_access")}</li>
              <li>{t("global.done_start_training")}!</li>
            </ul>
          </section>
        );
      }
      _content = (
        <>
          {infoHowToSend}

          <ListUsers
            users={listUser}
            company_uid={company_uid}
            showUser
            showActiveStatus
            showAccess_code
            showBirthdate
            showReportUserSmart
            showIaStart
            showIaFinish
            showDownloadListButton
            showActionButton
            setHasUserChangedGroup={fHasUserChangedGroup}
            CustomToolbar={CustomToolbar}
            configFields={configFields}
            handleSelectRowsToSetGroup={setSelectedRows}
            setHandleGroup={setHandleGroup}
            hasUserChangedGroup={hasUserChangedGroup}
          />
        </>
      );
      break;
    case ERROR_USERS:
      _content = <>Erro</>;
      break;
    default:
      _content = <Spinner center />;
      break;
  }

  return (
    <>
      <PageHeader
        title={t("global.users_added")}
        subtitle={t("global.list_active_users")}
        btnText={t("global.add_users")}
        btnClick={() => history(r.R_A_USERS_ADD_SMART)}
        companyId={company_uid}
        isAdmin={is_admin}
        hasNewGroups={hasNewGroups}
        setHasUserChangedGroup={setHasUserChangedGroup}
      />
      {ModalGroups}
      <PageMain>{_content}</PageMain>
    </>
  );
}
